module.exports = __webpack_public_path__ + "img/demo-interior-design-400x300.97f1a88f.jpg";